import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { 
  Sparkles, Video, Wand2, LogOut, ExternalLink, User
} from 'lucide-react';

const Dashboard: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  // Ouvrir un outil directement sans authentification
  const openTool = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: 'black', color: '#d1d5db' }}>
      {/* Header */}
      <header style={{ borderBottom: '1px solid #1f2937', backgroundColor: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(12px)', position: 'sticky', top: 0, zIndex: 50 }}>
        <div style={{ maxWidth: '80rem', margin: '0 auto', padding: '0 1rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '4rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <Sparkles style={{ width: '1.75rem', height: '1.75rem', color: '#3b82f6' }} />
              <h1 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: 'white' }}>Faissal SaaS</h1>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                {user?.photoURL ? (
                  <img src={user.photoURL} alt="" style={{ width: '2rem', height: '2rem', borderRadius: '9999px', border: '1px solid #4b5563' }} />
                ) : (
                  <div style={{ width: '2rem', height: '2rem', borderRadius: '9999px', backgroundColor: '#1f2937', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <User style={{ width: '1rem', height: '1rem', color: '#9ca3af' }} />
                  </div>
                )}
                <span style={{ color: '#d1d5db', fontSize: '0.875rem', display: 'none' }} className="sm:inline">{user?.displayName || user?.email}</span>
              </div>
              <button onClick={handleLogout} style={{ padding: '0.5rem', color: '#9ca3af', cursor: 'pointer', background: 'none', border: 'none' }}>
                <LogOut style={{ width: '1.25rem', height: '1.25rem' }} />
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main style={{ maxWidth: '72rem', margin: '0 auto', padding: '3rem 1rem' }}>
        {/* Welcome */}
        <div style={{ marginBottom: '2.5rem' }}>
          <h2 style={{ fontSize: '1.875rem', fontWeight: 'bold', color: 'white', marginBottom: '0.5rem' }}>Bienvenue !</h2>
          <p style={{ color: '#9ca3af' }}>Accédez à vos outils de création de contenu.</p>
        </div>

        {/* Tools Grid */}
        <h3 style={{ fontSize: '1.125rem', fontWeight: 600, color: 'white', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <Sparkles style={{ width: '1.25rem', height: '1.25rem', color: '#3b82f6' }} />
          Vos Outils
        </h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem', marginBottom: '2.5rem' }}>
          {/* RecipeVisual */}
          <button 
            onClick={() => openTool('https://recipevisual.faissalsaaf.com')}
            style={{ textAlign: 'left', backgroundColor: '#111827', border: '1px solid #1f2937', borderRadius: '1rem', padding: '1.5rem', cursor: 'pointer' }}
          >
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '1rem' }}>
              <div style={{ width: '4rem', height: '4rem', borderRadius: '0.75rem', background: 'linear-gradient(to bottom right, #a855f7, #ec4899)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Wand2 style={{ width: '2rem', height: '2rem', color: 'white' }} />
              </div>
              <span style={{ padding: '0.25rem 0.75rem', backgroundColor: 'rgba(34,197,94,0.1)', color: '#4ade80', fontSize: '0.75rem', fontWeight: 500, borderRadius: '9999px', border: '1px solid rgba(34,197,94,0.2)' }}>Disponible</span>
            </div>
            <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: 'white', marginBottom: '0.5rem' }}>RecipeVisual</h3>
            <p style={{ color: '#9ca3af', marginBottom: '1rem' }}>Générez des visuels Pinterest professionnels pour vos recettes.</p>
            <div style={{ display: 'flex', alignItems: 'center', fontSize: '0.875rem', color: '#60a5fa' }}>
              <span>Ouvrir l'outil</span>
              <ExternalLink style={{ width: '1rem', height: '1rem', marginLeft: '0.5rem' }} />
            </div>
          </button>

          {/* ReelCleaner */}
          <button 
            onClick={() => openTool('https://reelcleaner.faissalsaaf.com')}
            style={{ textAlign: 'left', backgroundColor: '#111827', border: '1px solid #1f2937', borderRadius: '1rem', padding: '1.5rem', cursor: 'pointer' }}
          >
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '1rem' }}>
              <div style={{ width: '4rem', height: '4rem', borderRadius: '0.75rem', background: 'linear-gradient(to bottom right, #3b82f6, #06b6d4)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Video style={{ width: '2rem', height: '2rem', color: 'white' }} />
              </div>
              <span style={{ padding: '0.25rem 0.75rem', backgroundColor: 'rgba(34,197,94,0.1)', color: '#4ade80', fontSize: '0.75rem', fontWeight: 500, borderRadius: '9999px', border: '1px solid rgba(34,197,94,0.2)' }}>Disponible</span>
            </div>
            <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: 'white', marginBottom: '0.5rem' }}>ReelCleaner</h3>
            <p style={{ color: '#9ca3af', marginBottom: '1rem' }}>Téléchargez et nettoyez vos vidéos Reels & TikToks.</p>
            <div style={{ display: 'flex', alignItems: 'center', fontSize: '0.875rem', color: '#60a5fa' }}>
              <span>Ouvrir l'outil</span>
              <ExternalLink style={{ width: '1rem', height: '1rem', marginLeft: '0.5rem' }} />
            </div>
          </button>
        </div>

        {/* Info */}
        <div style={{ padding: '1.5rem', backgroundColor: 'rgba(17,24,39,0.5)', border: '1px solid #1f2937', borderRadius: '1rem' }}>
          <h3 style={{ fontSize: '1.125rem', fontWeight: 600, color: 'white', marginBottom: '0.5rem' }}>Accès libre</h3>
          <p style={{ color: '#9ca3af' }}>
            Les outils sont maintenant accessibles directement sans authentification préalable.
          </p>
        </div>
      </main>

      {/* Footer */}
      <footer style={{ borderTop: '1px solid #1f2937', marginTop: '3rem' }}>
        <div style={{ maxWidth: '80rem', margin: '0 auto', padding: '1.5rem 1rem' }}>
          <p style={{ textAlign: 'center', color: '#6b7280', fontSize: '0.875rem' }}>
            © 2026 Faissal SaaS. Propulsé par Firebase.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Dashboard;
